import { EditIcon } from '@carboncopyco/icons';

export interface FieldLabelProps {
  label: string;
  htmlFor: string;
  editable?: boolean;
  onChange?: (value: string) => void;
}

export const FieldLabel = ({
  label,
  htmlFor,
  editable,
  onChange,
}: FieldLabelProps) => (
  <label
    className="group/label flex items-center gap-1.5 text-ds-natural-600 text-xs truncate"
    htmlFor={htmlFor}
  >
    <span
      className="min-w-[50px] focus:outline-ds-primary-300"
      contentEditable={editable}
      suppressContentEditableWarning
      onBlur={(e) => onChange?.(e.currentTarget.textContent)}
    >
      {label}
    </span>
    {editable && (
      <span className="group-hover/label:block group-focus-within/label:block hidden">
        <EditIcon size={16} />
      </span>
    )}
  </label>
);
